import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { initialState } from './initial';

const webLoginSlice = createSlice({
  name: 'weblogin',
  initialState,
  reducers: {
    setFormType(state, action: PayloadAction<'login' | 'registration'>) {
      state.form.type = action.payload;
    },
  },
});

export const { actions: webLoginActions } = webLoginSlice;
export const { reducer: webLoginReducer } = webLoginSlice;
